import {
    withHeaders,
    instance as axiosInstance,
} from '../core/util/axiosInstance';
import { getDefaultHeaders, useAlert } from '../core';
import { MutationFunction, UseMutationResult, useMutation } from 'react-query';
import { AxiosResponse } from 'axios';
import { commonShowAlert } from '../lib';
import { FileData } from '../pages/job-manager/components/create-job-dialog';
import { FILE_UPLOAD_SUCCESS_MSG } from '../pages/job-manager/job-manager-helper';

interface PostUploadFileProps {
    file: FileData;
    token: string;
    email: string;
    operation: string;
    chain: string;
    owners?: string[];
    limitedOwners?: string[];
}

export const postUploadFile: MutationFunction<
    AxiosResponse<any>,
    PostUploadFileProps
> = async (props: PostUploadFileProps) => {
    const { file, token, email, operation, chain, owners, limitedOwners } =
        props;
    const headers = getDefaultHeaders(token);
    const createFileUploadJobUrl = `/jobs/${chain}/upload`;

    const formData = new FormData();
    const response = await fetch(file.url);
    const blob = await response.blob();
    formData.append('file', blob, file.name);
    formData.append('chain', chain);
    if (owners?.length) {
        formData.append('owners', JSON.stringify(owners));
    }
    if (limitedOwners?.length) {
        formData.append('limitedOwners', JSON.stringify(limitedOwners));
    }
    formData.append('operation', operation);
    if (email) {
        formData.append('emailResultsTo', email);
    }
    return axiosInstance().post(
        createFileUploadJobUrl,
        formData,
        withHeaders(headers)
    );
};

export const useUploadFile = (): UseMutationResult<
    AxiosResponse<any>,
    unknown,
    PostUploadFileProps
> => {
    const { showAlert, hideAlert, showErrorDetails } = useAlert();

    return useMutation(postUploadFile, {
        onSuccess: () => {
            commonShowAlert(
                showAlert,
                hideAlert,
                'success',
                FILE_UPLOAD_SUCCESS_MSG
            );
        },
        onError: (error: any) => {
            const errorMessage: string =
                error?.data?.message ?? 'Unable to create file upload job';
            commonShowAlert(
                showAlert,
                hideAlert,
                'error',
                errorMessage,
                JSON.stringify(error?.data ?? ''),
                showErrorDetails
            );
        },
    });
};
